import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { TemplateDraft } from "@core/types";
import * as api from "./api";
import type { TemplateEditInput } from "./api";

const listKey = ["portal", "message-templates"] as const;

export const useTemplates = () =>
  useQuery({ queryKey: listKey, queryFn: api.listTemplates });

// SPEC-218 no pagina ni filtra en el servidor: las ocho plantillas se traen
// completas (mismo criterio que `useOffers`/`useBenefits`).
export function useTemplateMutations() {
  const client = useQueryClient();
  const invalidate = () => client.invalidateQueries({ queryKey: listKey });
  return {
    // La primera llamada nunca manda `confirmed: true`: si el servidor
    // responde 409 (`CONFIRM_CRITICAL`/`CONFIRM_DEACTIVATE`), quien llama
    // reintenta con `confirmed: true` (SPEC-218 §5/§6, criterios 5 y 7). No
    // hay un segundo endpoint.
    edit: useMutation({
      mutationFn: ({
        code,
        input,
      }: {
        code: string;
        input: TemplateEditInput;
      }) => api.editTemplate(code, input),
      onSuccess: invalidate,
    }),
    // Sin invalidación: previsualizar y probar no cambian el registro
    // persistido (PA-036-E).
    preview: useMutation({
      mutationFn: ({ code, draft }: { code: string; draft: TemplateDraft }) =>
        api.previewTemplate(code, draft),
    }),
    sendTest: useMutation({
      mutationFn: ({ code, draft }: { code: string; draft: TemplateDraft }) =>
        api.sendTemplateTest(code, draft),
    }),
  };
}
